import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { DepositPaymentSettings, DepositPaymentSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const DEPOSIT_PAYMENT_SETTINGS_URL = `${SETTINGS_BASE_URL}/depositpayment`;

export class DepositPaymentSettingsRepository extends BaseRestRepository {
  public async getAllDepositPaymentSettings(): Promise<DepositPaymentSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${DEPOSIT_PAYMENT_SETTINGS_URL}/with-overrides`;
    const res = await this.fetchWithAuth(url);
    return this.getJsonResponse(res);
  }

  public async updateDepositSettings(payload: Partial<DepositPaymentSettings>): Promise<DepositPaymentSettings> {
    const url = `${DEPOSIT_PAYMENT_SETTINGS_URL}/company`;
    const res = await this.fetchWithAuth(url, { method: 'POST', body: JSON.stringify({ settings: payload }) });
    return this.getJsonResponse(res);
  }

  public async updateOverrideDepositSettings(
    level: string,
    levelId: string,
    payload: DepositPaymentSettings
  ): Promise<DepositPaymentSettings> {
    const url = DEPOSIT_PAYMENT_SETTINGS_URL;
    const res = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(res);
  }

  public async addOverrideSettings(level: string, levelId: string, payload: DepositPaymentSettings): Promise<DepositPaymentSettings> {
    const url = DEPOSIT_PAYMENT_SETTINGS_URL;
    const res = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(res);
  }

  public async removeOverrideSettings(level: string, levelId: string) {
    const url = `${DEPOSIT_PAYMENT_SETTINGS_URL}/${level}/${levelId}`;
    const res = await this.fetchWithAuth(url, { method: 'DELETE' });
    return this.getJsonResponse(res);
  }
}

export const depositPaymentSettingsRepository = new DepositPaymentSettingsRepository();
